import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ShoppingCategoryData, ShoppingFilterData } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

import { AssetCategoryFilterComponent } from '../asset-category-filter/asset-category-filter.component';
import { FiltersComponent } from '../filters/filters.component';

@Component({
  selector: 'ts-filters-index',
  templateUrl: './filters-index.component.html',
  imports: [CommonModule, TranslationPipe, AssetCategoryFilterComponent, FiltersComponent]
})
export class FiltersIndexComponent {
  @Input() categories: ShoppingCategoryData[];
  @Input() filters: ShoppingFilterData[];
  @Input() is_mobile: boolean = false;

  get has_filters(): boolean {
    return this.filters?.length > 0;
  }
}
